import styled from 'styled-components';

import { BodilColor } from '~src/branding';

export const StepContainer = styled.div({
  display: 'grid',
  flex: '1 1',
  gap: '8px',
  gridTemplateColumns: '32px 1fr 48px 1fr 48px 1fr',
  gridTemplateRows: 'auto auto auto',
  margin: '32px 0 0 0',
  wordWrap: 'break-word',
});

export const StepIcon = styled.p<{ norlys?: boolean; primary?: boolean }>(({ norlys, primary }) => ({
  alignSelf: 'center',
  aspectRatio: '1/1',
  backgroundColor: norlys ? (primary ? '#33D189' : '#D4F4E8') : primary ? '#FFA346' : '#F9DEC5',
  borderRadius: '50%',
  color: BodilColor.base.white,
  display: 'grid',
  fontSize: '16px',
  justifySelf: 'end',
  margin: 0,
  lineHeight: '16px',
  placeContent: 'center',
  width: '32px',
}));

export const StepImage = styled.img({
  justifySelf: 'center',
});
